<template>
     <el-popover
        placement="bottom-end"
        width="375"
        trigger="click"
        v-model="popShow"
    >
        <el-button 
            slot="reference" 
            size="small" 
            plain
        >
            <i class="el-icon-tickets"></i>
            Exportar Relatório
        </el-button>

        <div>
            <h5 class="font-weight-bold mb-3">Relatórios da agenda</h5>

            <el-divider class="mt-3"></el-divider>

            <el-form 
                :model="filters" 
                ref="eventExportReport" 
                label-position="top" 
                status-icon 
            >
                <!-- File types -->
                <el-form-item 
                    prop="type_report"
                    :rules="[{ required: true, message: 'Selecione o tipo de arquivo para exportação', trigger: 'change' }]"
                >
                    <div class="d-flex align-items-center justify-content-center" :style="{ gap: '12px' }">
                        <div 
                            v-for="(typeRepo) in typesReports"
                            class="d-flex flex-column align-items-center"
                            :style="{ gap: '12px', cursor: 'pointer'}"
                        >
                            <div 
                                class="rounded d-flex justify-content-center align-items-center position-relative"
                                :style="{ 
                                    width: '64px', 
                                    height: '64px',
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: typeRepo.name == 'XLS' 
                                        ? '#c2e7b0'
                                        : '#fbc4c4',
                                    backgroundColor: typeRepo.name == 'XLS' 
                                        ? '#f0f9eb' 
                                        : '#fef0f0'
                                }"
                                @click="chooseAgendaReportUrl(typeRepo.name)"
                            >
                                <svg v-if="typeRepo.name == 'XLS'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#67C23A" class="bi bi-filetype-xls" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"/>
                                </svg>

                                <svg v-if="typeRepo.name == 'PDF'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#F56C6C" class="bi bi-filetype-pdf" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                                </svg>
                                
                                <span 
                                    v-if="filters.type_report != null && filters.type_report === typeRepo.name"
                                    class="rounded-circle bg-success position-absolute"
                                    :style="{
                                        width: '16px',
                                        height: '16px',
                                        right: '-4px',
                                        top: '-4px',
                                    }"
                                ></span>
                            </div>
                            <h5 class="font-weight-bolder text-center">{{ typeRepo.name }}</h5>
                        </div>
    
                    </div>
                </el-form-item>

                <el-row :gutter="20">
                    <el-col>
                        <el-form-item prop="consultant_user_id">
                            <label>Consultor</label>
                            <el-select
                                size="small"
                                v-model="filters.consultant_user_id"
                                placeholder="Selecionar consultor"
                                :disabled="isLoading"
                                filterable 
                            >
                                <el-option
                                    v-for="(sale) in sales"
                                    :key="sale.user_id"
                                    :value="sale.user_id"
                                    :label="sale.text"
                                    class="text-truncate"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
    
                    <el-col>
                        <el-form-item prop="status">
                            <label>Status</label>
                            <el-select
                                size="small"
                                v-model="filters.status"
                                placeholder="Selecionar status"
                                filterable 
                            >
                                <el-option :value="null">Todos</el-option>
                                <el-option
                                    v-for="(stat) in status"
                                    :key="stat.value"
                                    :value="stat.value"
                                >
                                    <div class="d-flex align-items-center">
                                        <el-tag 
                                            v-if="stat.value != null"
                                            :type="getEventColorByStatus(stat.value)" 
                                            size="mini"
                                            :style="{ width: '20px' }"
                                            class="rounded-circle mr-2"
                                        >
                                        </el-tag>
                                        {{ stat.text }}
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
    
    
                    <el-col>
                        <el-form-item 
                            prop="periodo"
                            :rules="[{ required: true, message: 'O período é obrigatório', trigger: 'change' }]"
                        >
                            <label>Período</label>
                            <el-date-picker
                                unlink-panels
                                size="small"
                                v-model="filters.periodo"    
                                type="daterange"
                                start-placeholder="Inicio"
                                end-placeholder="Fim"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                            />
                        </el-form-item>
                    </el-col>
    
                    <el-col>
                       <div class="d-flex justify-content-end">
                            <el-button
                                size="small" 
                                :type="this.filters.type_report == 'XLS' 
                                    ? 'success' 
                                    : (this.filters.type_report == 'PDF' 
                                        ? 'danger' 
                                        : 'primary'
                                    )
                                "
                                plain
                                :disabled="isLoading"
                                @click="exportReport"
                            >
                                <i class="el-icon-tickets"></i>

                                <span v-if="this.filters.type_report == 'XLS'">Gerar relátorio</span>
                                <span v-else-if="this.filters.type_report == 'PDF'">Gerar PDF</span>
                                <span v-else>Gerar</span>
                            </el-button>
                       </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </el-popover>
</template>
<script>
    import {
        Card,
        Button,
        Row,
        Col,
        Form,
        FormItem,
        Select,
        Option,
        RadioGroup,
        RadioButton,
        Notification,
        Tag,
        Avatar,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Empty,
        Popover,
        Divider,
        Badge
    } from 'element-ui'

    //Api
    import { VendedorApi } from "@/api/VendedorApi";
    const vendedorApi = new VendedorApi();

    import { AgendaApi } from '@/api/AgendaApi';
    const agendaApi = new AgendaApi();

    export default {
        data() {
            return {
                popShow: false,
                isLoading: false,
                typeReportUrl: null,
                filters: {
                    periodo: null,
                    status: null,
                    consultant_user_id: null,
                    type_report: null
                },
                sales: [],
                status: [
                    { value: "CUMPRIDO", text: "Cumpriu" },
                    { value: "PENDENTE", text: "Pendente" },
                    { value: "APROVADO", text: "Aprovado" },
                    { value: "NAO CUMPRIU", text: "Não cumpriu" },
                    { value: "REPROVADO", text: "Reprovado" },
                ],
                typesReports: [
                    {
                        id: 1,
                        name: 'XLS',
                    },
                    {
                        id: 2,
                        name: 'PDF'
                    }
                ]
            }
        },
        methods: {
            /**
             * Obtem os vendedores
             */
            async exportReport() {
                this.$refs.eventExportReport.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    let url = null

                    if (this.filters.type_report == 'XLS') {
                        url = "/adm/exportar-agenda";
                    }
    
                    if (this.filters.type_report == "PDF") {
                        url = "/adm/exportar-agenda-pdf";
                    } 
                    
                    const elLoading = this.$loading({ lock: true, text: "Gerando arquivo..." })

                    try {

                        const res = await agendaApi.getScheduleLink({
                            de: this.filters.periodo[0],
                            ate: this.filters.periodo[1],
                            status: this.filters.status,
                            consultor: this.filters.consultant_user_id,
                        });
    
                        window.open(`${url}/${res.resource}`, '_blank');
                    } catch (err) {
                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível obter o link da agenda!'
                        });
                    } finally {
                        elLoading.close();
                    }
                });
            },
            async getSales() {
                try {
                    this.isLoading = true;
                    const res = await vendedorApi.pluck()

                    this.sales = res.data;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os vendedores!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            getEventColorByStatus(status) {
                switch(status) {
                    case 'APROVADO':
                        return 'success'
                    case 'PENDENTE':
                        return 'warning'
                    case 'CUMPRIDO':
                        return '' 
                    case 'NAO CUMPRIU':
                        return 'danger' 
                    case 'REPROVADO':
                        return 'info' 
                    default: 
                        return 'info'
                }
            },
            chooseAgendaReportUrl(typeReport) {
                if (typeReport == 'PDF') {
                    this.filters.type_report = 'PDF'
                }

                if (typeReport == 'XLS') {
                     this.filters.type_report = 'XLS'
                }

                this.$nextTick(() => {
                    this.$refs.eventExportReport.validateField('type_report');
                });
            }
        },  
        watch: {
            "popShow"(_newValue) {
                if(_newValue == false) {
                    this.$refs.eventExportReport.resetFields();
                }
            },
        },
        mounted() {
            this.getSales()
        },
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Select.name]: Select,
            [Option.name]: Option,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Notification.name]: Notification,
            [Tag.name]: Tag,
            [Avatar.name]: Avatar,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Empty.name]: Empty,
            [Popover.name]: Popover,
            [Divider.name]: Divider,
            [Badge.name]: Badge
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/EventsExportReports.vue